export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',

  // 通用按钮与标签
  'pages.common.create': '新建',
  'pages.common.edit': '编辑',
  'pages.common.delete': '删除',
  'pages.common.detail': '详情',
  'pages.common.status': '状态',
  'pages.common.actions': '操作',
  'pages.common.search': '搜索',
  'pages.common.reset': '重置',
  'pages.common.export': '导出',
  'pages.common.download': '下载',
  'pages.common.refresh': '刷新',
  'pages.common.confirm': '确认',
  'pages.common.cancel': '取消',
  'pages.common.retry': '重试',
  'pages.common.replay': '重处理',
  'pages.common.resend': '补发',
  'pages.common.copy': '复制',
  'pages.common.copySuccess': '复制成功',

  // P-01 运行看板
  'pages.dashboard.title': '运行看板',
  'pages.dashboard.overview': 'EDI 运行全景看板',
  'pages.dashboard.desc':
    '实时监控今日收发总量、成功率、异常分布与接入伙伴状态。',
  'pages.dashboard.filter.timeRange': '时间范围',
  'pages.dashboard.filter.today': '今日 (24h)',
  'pages.dashboard.filter.7days': '近 7 天',
  'pages.dashboard.filter.30days': '近 30 天',
  'pages.dashboard.metric.todayTotal': '今日收发总量',
  'pages.dashboard.metric.inbound': '入站',
  'pages.dashboard.metric.outbound': '出站',
  'pages.dashboard.metric.successRate': '处理成功率',
  'pages.dashboard.metric.errorCount': '异常报文数',
  'pages.dashboard.metric.onlinePartners': '活跃伙伴',
  'pages.dashboard.metric.activePartners': '活跃伙伴',
  'pages.dashboard.metric.activeRate': '活跃率',
  'pages.dashboard.metric.enabledCount': '已启用 {count} 家',
  'pages.dashboard.metric.yoy': '较昨日同时段',
  'pages.dashboard.trend.title': '收发量趋势',
  'pages.dashboard.trend.chartTitle': '收发量趋势图',
  'pages.dashboard.trend.inboundLegend': '入站报文',
  'pages.dashboard.trend.outboundLegend': '出站报文',
  'pages.dashboard.errorDist.title': '异常分布',
  'pages.dashboard.errorDist.chartTitle': '异常分布图',
  'pages.dashboard.errorDist.totalError': '总异常',
  'pages.dashboard.errorDist.empty': '暂无异常数据',
  'pages.dashboard.partnerStatus.title': '接入伙伴状态',
  'pages.dashboard.partnerStatus.pinned': '异常置顶',
  'pages.dashboard.partnerStatus.partnerName': '伙伴名称',
  'pages.dashboard.partnerStatus.protocol': '协议',
  'pages.dashboard.partnerStatus.lastComm': '最近通信时间',
  'pages.dashboard.partnerStatus.todayVol': '今日收发量',
  'pages.dashboard.partnerStatus.rate': '成功率',
  'pages.dashboard.partnerStatus.status': '状态',
  'pages.dashboard.partnerStatus.healthy': '正常',
  'pages.dashboard.partnerStatus.warning': '异常',
  'pages.dashboard.partnerStatus.idle': '无流量',
  'pages.dashboard.partnerStatus.disabled': '已停用',
  'pages.dashboard.todos.title': '待处理失败报文',
  'pages.dashboard.todos.failedTotal': '待处理失败',
  'pages.dashboard.todos.viewAll': '查看全部',
  'pages.dashboard.todos.empty': '暂无待处理失败报文',
  'pages.dashboard.todos.unhandledAlerts': '高优未处理预警',
  'pages.dashboard.todos.overdueWorkorders': '超时未处理工单',
  'pages.dashboard.todos.occurrence': '发生 {count} 次',
  'pages.dashboard.todos.overdue': '逾期 {min} 分钟',
  'pages.dashboard.todos.viewAllAlerts': '查看全部预警',
  'pages.dashboard.todos.viewAllWorkorders': '查看全部工单',

  'pages.common.noPermission': '暂无操作权限',

  // P-02 交易伙伴列表
  'pages.access.partners.title': '交易伙伴管理',
  'pages.access.partners.desc':
    '管理船司、码头、场站及内部系统等交易伙伴的协议与回执层级配置。',
  'pages.access.partners.create': '新建交易伙伴',
  'pages.access.partners.searchPlaceholder': '搜索伙伴名称 / 编码',
  'pages.access.partners.colName': '伙伴名称',
  'pages.access.partners.colCode': '伙伴编码',
  'pages.access.partners.colType': '伙伴类型',
  'pages.access.partners.colProtocols': '启用协议',
  'pages.access.partners.colReceipts': '已声明回执层级',
  'pages.access.partners.colStatus': '状态',
  'pages.access.partners.colConnectivity': '连通性测试',
  'pages.access.partners.colLastComm': '最近通信时间',
  'pages.access.partners.type.carrier': '船公司',
  'pages.access.partners.type.port': '港口码头',
  'pages.access.partners.type.yard': '物流场站',
  'pages.access.partners.type.railway': '铁路联运',
  'pages.access.partners.type.internal': '内部系统',
  'pages.access.partners.status.draft': '草稿',
  'pages.access.partners.status.pendingReview': '待审核',
  'pages.access.partners.status.enabled': '已启用',
  'pages.access.partners.status.disabled': '已停用',
  'pages.access.partners.testConnectivity': '连通性测试',
  'pages.access.partners.testingConnectivity': '测试中...',
  'pages.access.partners.testSuccess': '连通性测试通过！耗时: {latency}ms',
  'pages.access.partners.testFailed': '连通性测试失败',
  'pages.access.partners.enable': '启用',
  'pages.access.partners.disable': '停用',
  'pages.access.partners.submitReview': '提交审核',
  'pages.access.partners.enableDisabledUntested':
    '未通过连通性测试，无法启用。请先执行连通性测试。',
  'pages.access.partners.disableConfirmTitle': '确认停用交易伙伴',
  'pages.access.partners.disableConfirmImpact':
    '停用后将立即中断与该主体的所有实时 EDI 交互链路，相关通道将停止接收或投递该主体的业务报文。',
  'pages.access.partners.disableSuccess': '伙伴已停用',
  'pages.access.partners.enableSuccess': '伙伴已启用',
  'pages.access.partners.submitReviewSuccess': '接入申请已提交审核',
  'pages.access.partners.emptyDesc':
    '暂无交易伙伴，请先创建首个船司或港区交易伙伴',
  'pages.access.partners.createTitle': '新建交易伙伴',
  'pages.access.partners.step1': '基本信息',
  'pages.access.partners.step2': '协议与通道',
  'pages.access.partners.step3': '回执层级与超时',
  'pages.access.partners.step4': '权限与生效',
  'pages.access.partners.createSuccess': '交易伙伴创建成功',
  'pages.access.partners.tested': '已通过',
  'pages.access.partners.untested': '未测试',
  'pages.access.partners.status.underReview': '审核中',
  'pages.access.partners.type.carrierFull': '船公司 (Carrier)',
  'pages.access.partners.type.portFull': '港口码头 (Port)',
  'pages.access.partners.type.yardFull': '物流场站 (Yard)',
  'pages.access.partners.type.railwayFull': '铁路联运 (Railway)',
  'pages.access.partners.type.internalFull': '内部系统 (Internal)',
  'pages.access.partners.protocol.ftpCompat': 'FTP (兼容通道)',
  'pages.access.partners.initialStatus.draft': '保存为草稿 (DRAFT)',

  // P-03 交易伙伴详情
  'pages.access.partnerDetail.title': '交易伙伴详情',
  'pages.access.partnerDetail.desc':
    '配置协议通道、回执层级与超时时长，绑定标准版本与数字证书。',
  'pages.access.partnerDetail.backToList': '返回伙伴列表',
  'pages.access.partnerDetail.tabProtocols': '协议与通道配置',
  'pages.access.partnerDetail.tabReceipts': '回执时限',
  'pages.access.partnerDetail.tabStandards': '报文标准与映射',
  'pages.access.partnerDetail.tabCertificates': '伙伴证书',
  'pages.access.partnerDetail.tabHistory': '变更记录',
  'pages.access.partnerDetail.receiptNotice':
    '说明：未开启的层级不参与超时计算、不产生预警。系统仅对已开启的层级进行超时监控与倒计时。',
  'pages.access.partnerDetail.transportAck': '传输回执 (Transport Ack)',
  'pages.access.partnerDetail.transportAckDesc':
    '对应 AS2 MDN、OFTP EERP、SFTP 落盘确认或 HTTP 状态响应',
  'pages.access.partnerDetail.syntaxAck': '语法回执 (Syntax Ack)',
  'pages.access.partnerDetail.syntaxAckDesc':
    '对应 UN/EDIFACT CONTRL 报文，确认结构与字段解析正确性',
  'pages.access.partnerDetail.appAck': '应用回执 (Application Ack)',
  'pages.access.partnerDetail.appAckDesc':
    '对应 APERAK 或业务受理回执，只有该层成功才判定为业务受理',
  'pages.access.partnerDetail.timeoutMinutes': '超时时长 (分钟)',
  'pages.access.partnerDetail.saveReceipts': '保存回执配置',
  'pages.access.partnerDetail.saveReceiptsSuccess':
    '回执层级与超时配置保存成功',
  'pages.access.partnerDetail.previewTitle': '当前声明下的报文状态效果预览',
  'pages.access.partnerDetail.previewDesc':
    '根据本主体当前声明的回执层级，报文处理流转状态展示如下（未声明的层级不渲染）：',
  'pages.access.partnerDetail.stdColName': '标准名称',
  'pages.access.partnerDetail.stdColVersion': '版本',
  'pages.access.partnerDetail.stdColGray': '灰度状态',
  'pages.access.partnerDetail.stdGrayYes': '灰度生效中',
  'pages.access.partnerDetail.stdGrayNo': '全量生效',
  'pages.access.partnerDetail.viewStd': '查看标准',
  'pages.access.partnerDetail.viewMapping': '查看映射',
  'pages.access.partnerDetail.histColTime': '变更时间',
  'pages.access.partnerDetail.histColOperator': '操作人',
  'pages.access.partnerDetail.histColField': '变更字段',
  'pages.access.partnerDetail.histColBefore': '变更前',
  'pages.access.partnerDetail.histColAfter': '变更后',
  'pages.access.partnerDetail.histColIp': '终端 IP',
  'pages.access.partnerDetail.testResultTitle': '连通性测试记录',
  'pages.access.partnerDetail.testResultSuccess': '测试通过',
  'pages.access.partnerDetail.testResultLatency': '延迟: {latency}ms',
  'pages.access.partnerDetail.testResultCert': '证书指纹: {fingerprint}',
  'pages.access.partnerDetail.testResultTime': '测试时间: {time}',
  'pages.access.partnerDetail.protocolCard': '协议配置卡片',
  'pages.access.partnerDetail.timeoutLabel': '超时时长:',
  'pages.access.partnerDetail.previewSent': '已发送 (SENT):',
  'pages.access.partnerDetail.previewDelivered': '已投递 (DELIVERED):',
  'pages.access.partnerDetail.previewTimeout': '回执超时场景:',
  'pages.access.partnerDetail.boundStandardsTitle': '已绑定的报文标准',
  'pages.access.partnerDetail.relatedRulesTitle': '订阅的报文类型',

  // P-04 接入通道
  'pages.access.channels.title': '接入通道管理',
  'pages.access.channels.desc':
    '统一管理本方传输通道与协议配置；伙伴发送目标和协议约定在交易伙伴中维护。',
  'pages.access.channels.resourcesTab': '通道资源',
  'pages.access.channels.localProtocolsTab': '本方协议设置',
  'pages.access.channels.create': '新建通道',
  'pages.access.channels.allProtocols': '全部协议',
  'pages.access.channels.health.healthy': '正常 (Healthy)',
  'pages.access.channels.health.warning': '预警 (Warning)',
  'pages.access.channels.health.down': '离线故障 (Down)',
  'pages.access.channels.boundPartners': '绑定交易伙伴',
  'pages.access.channels.todayTraffic': '今日传输流量',
  'pages.access.channels.lastHeartbeat': '最近探活心跳',
  'pages.access.channels.failoverTitle': '主备容灾切换配置',
  'pages.access.channels.primaryChannel': '主通道',
  'pages.access.channels.backupChannel': '备用通道',
  'pages.access.channels.strategy': '切换策略',
  'pages.access.channels.strategyAuto': '故障自动切换 (Auto)',
  'pages.access.channels.strategyManual': '人工确认切换 (Manual)',
  'pages.access.channels.primaryChannelLabel': '主通道: ',
  'pages.access.channels.backupChannelLabel': '备用通道: ',
  'pages.access.channels.protocol.ftpLegacy': 'FTP (兼容老系统)',
  'pages.access.channels.strategyAutoFull': '心跳探活失败自动切换 (Auto)',
  'pages.access.channels.strategyManualFull': '人工确认后手动切换 (Manual)',
  'pages.access.channels.lastSwitch': '最近切换记录',
  'pages.access.channels.switchedAt': '切换时间',
  'pages.access.channels.switchReason': '切换原因',
  'pages.access.channels.duration': '持续时长',
  'pages.access.channels.recoveryStatus': '恢复结果',
  'pages.access.channels.recovered': '已恢复主通道',
  'pages.access.channels.inFailover': '备用通道接管中',
  'pages.access.channels.ping': '探活测试',
  'pages.access.channels.pinging': '探活中...',
  'pages.access.channels.pingSuccess':
    '探活成功！响应时间: {latency}ms，通道状态正常',
  'pages.access.channels.switchHistory': '切换历史',
  'pages.access.channels.emptyDesc': '暂无接入通道，请先添加传输通道',
  'pages.access.channels.createTitle': '新建传输通道',
  'pages.access.channels.createSuccess': '传输通道创建成功',

  // P-05 证书与密钥
  'pages.access.certificates.title': '证书与密钥管理',
  'pages.access.certificates.desc':
    '管理签名、加密与 TLS 证书，提供临期高亮预警、证书创建与吊销能力。',
  'pages.access.certificates.import': '导入证书',
  'pages.access.certificates.generateCsr': '生成证书',
  'pages.access.certificates.colName': '证书名称',
  'pages.access.certificates.colPartner': '所属交易伙伴',
  'pages.access.certificates.colUsage': '用途',
  'pages.access.certificates.colMaterialType': '材料类型',
  'pages.access.certificates.colAlgorithm': '算法',
  'pages.access.certificates.colFingerprint': '指纹 (SHA-256)',
  'pages.access.certificates.colIssuer': '颁发者',
  'pages.access.certificates.colValidity': '有效期限',
  'pages.access.certificates.colDaysRemaining': '剩余天数',
  'pages.access.certificates.colStatus': '状态',
  'pages.access.certificates.usage.signing': '签名 (Signing)',
  'pages.access.certificates.usage.encryption': '加密 (Encryption)',
  'pages.access.certificates.usage.tls': 'TLS 通信',
  'pages.access.certificates.usage.tlsMutual': '双向 TLS 通信',
  'pages.access.certificates.samplePartnerHMM': '现代商船 HMM',
  'pages.access.certificates.samplePartnerMSC': '地中海航运 MSC',
  'pages.access.certificates.samplePartnerMaersk':
    '马士基航运 A.P. Moller - Maersk',
  'pages.access.certificates.samplePartnerCosco':
    '中远海运集装箱运输有限公司全球运营中心',
  'pages.access.certificates.algo.rsa2048': 'RSA 2048 位',
  'pages.access.certificates.algo.rsa4096': 'RSA 4096 位',
  'pages.access.certificates.algo.sm2': 'SM2 国密算法',
  'pages.access.certificates.generatedCsrTitle':
    '生成的证书申请（请复制并提交 CA 签发）：',
  'pages.access.certificates.status.normal': '正常',
  'pages.access.certificates.status.expiringSoon': '即将到期',
  'pages.access.certificates.status.expired': '已过期',
  'pages.access.certificates.status.revoked': '已吊销',
  'pages.access.certificates.daysExpired': '已过期 {days} 天',
  'pages.access.certificates.daysRemainingUrgent': '剩余 {days} 天 (紧急)',
  'pages.access.certificates.daysRemainingWarning': '剩余 {days} 天 (临期)',
  'pages.access.certificates.daysRemainingNormal': '剩余 {days} 天',
  'pages.access.certificates.downloadPublicKey': '下载公钥证书',
  'pages.access.certificates.downloadPrivateKey': '下载私钥证书',
  'pages.access.certificates.downloading': '下载中...',
  'pages.access.certificates.downloadSuccess': '公钥证书已导出并下载',
  'pages.access.certificates.privateKeyNotice':
    '安全提示：私钥仅可导出为受密码保护的 PFX，密码不会保存到平台。',
  'pages.access.certificates.rotate': '轮换',
  'pages.access.certificates.revoke': '吊销',
  'pages.access.certificates.revokeConfirmTitle': '确认吊销数字证书',
  'pages.access.certificates.revokeConfirmImpact':
    '吊销证书为不可逆安全操作；关联交易伙伴的运行中接入路由会停用，并需重新完成配置和连通性测试后才能恢复。',
  'pages.access.certificates.revokeSuccess': '证书已吊销，关联交易伙伴已停用',
  'pages.access.certificates.emptyDesc':
    '暂无数字证书与密钥材料，请导入证书或生成证书',
  'pages.access.certificates.importSuccess': '证书导入成功',
  'pages.access.certificates.csrSuccess': '证书申请已生成',

  // P-06 报文标准库
  'pages.standards.library.title': '报文标准库',
  'pages.standards.library.desc':
    '统一管理 UN/EDIFACT、GB/T 及企业自定义标准体系，支持多版本并存、版本折叠与派生。',
  'pages.standards.library.create': '新建标准',
  'pages.standards.library.derive': '派生新版本',
  'pages.standards.library.import': '导入标准',
  'pages.standards.library.colCode': '标准编号',
  'pages.standards.library.colName': '标准名称',
  'pages.standards.library.colSystem': '体系',
  'pages.standards.library.colVersion': '当前版本',
  'pages.standards.library.colMsgType': '报文类型',
  'pages.standards.library.colStatus': '状态',
  'pages.standards.library.colPartners': '适用交易伙伴数',
  'pages.standards.library.colUpdatedAt': '更新时间',
  'pages.standards.library.system.unEdifact': 'UN/EDIFACT (国际标准)',
  'pages.standards.library.system.gbT': 'GB/T (国家标准)',
  'pages.standards.library.system.enterprise': '企业自定义标准',
  'pages.standards.library.status.draft': '草稿',
  'pages.standards.library.status.reviewing': '审核中',
  'pages.standards.library.status.published': '已发布',
  'pages.standards.library.status.archived': '已归档',
  'pages.standards.library.defaultVersion': '当前默认版本',
  'pages.standards.library.setDefault': '设为默认',
  'pages.standards.library.diff': '差异对比',
  'pages.standards.library.emptyDesc': '暂无报文标准，请新建或导入标准',
  'pages.standards.library.createSuccess': '报文标准创建成功',
  'pages.standards.library.deriveSuccess': '已成功派生新版本',
  'pages.standards.library.setDefaultSuccess': '已切换默认版本',
  'pages.standards.library.versionHistory': '版本历史与并存版本',
  'pages.standards.library.searchPlaceholder': '搜索标准编号 / 名称',

  // P-07 标准详情与结构编辑
  'pages.standards.standardDetail.title': '标准详情与结构编辑',
  'pages.standards.standardDetail.desc':
    '段组树结构编辑、节点约束配置与版本发布影响面校验。',
  'pages.standards.detail.back': '返回标准库',
  'pages.standards.detail.version': '当前版本',
  'pages.standards.detail.diffBtn': '版本对比 (Diff)',
  'pages.standards.detail.rulesSummary': '校验规则总览',
  'pages.standards.detail.publishBtn': '发布标准',
  'pages.standards.detail.structureTree': '报文结构树',
  'pages.standards.detail.nodeProperties': '节点属性配置',
  'pages.standards.detail.fieldCode': '字段编码',
  'pages.standards.detail.fieldName': '字段名称',
  'pages.standards.detail.dataType': '数据类型',
  'pages.standards.detail.length': '字段长度',
  'pages.standards.detail.mandatory': '必填属性',
  'pages.standards.detail.required': '必填 (Mandatory)',
  'pages.standards.detail.optional': '可选 (Optional)',
  'pages.standards.detail.repeat': '最大重复次数',
  'pages.standards.detail.valueRange': '取值范围 / 正则约束',
  'pages.standards.detail.dictBinding': '关联码值字典',
  'pages.standards.detail.validationRule': '合规校验规则',
  'pages.standards.detail.addNode': '添加子节点',
  'pages.standards.detail.deleteNode': '删除节点',
  'pages.standards.detail.saveProps': '保存节点属性',
  'pages.standards.detail.publishModalTitle': '确认发布标准版本',
  'pages.standards.detail.publishSuccess': '标准版本已成功发布并同步至转换引擎',
  'pages.standards.detail.nodeSaveSuccess': '节点属性已保存',
  'pages.standards.detail.rulesOverviewTitle': '报文结构全量校验规则总览',

  // P-08 映射规则
  'pages.standards.messageType.title': '报文类型管理',
  'pages.standards.messageType.desc':
    '管理标准与内部数据模型之间的双向映射转换规则及版本迁移。',
  'pages.standards.messageType.create': '新建报文类型',
  'pages.standards.messageType.migrate': '版本迁移',
  'pages.standards.messageType.copy': '复制',
  'pages.standards.messageType.designer': '设计规则',
  'pages.standards.messageType.colName': '报文类型名称',
  'pages.standards.messageType.colDirection': '方向',
  'pages.standards.messageType.colSource': '源标准及版本',
  'pages.standards.messageType.colTarget': '目标标准及版本',
  'pages.standards.messageType.colExternalEnd': '外部标准端',
  'pages.standards.messageType.colInternalEnd': '内部模型端',
  'pages.standards.messageType.colSubscribers': '订阅伙伴数',
  'pages.standards.messageType.colCurrentVersion': '当前版本',
  'pages.standards.messageType.colCode': '报文类型编码',
  'pages.standards.messageType.colPartner': '绑定交易伙伴',
  'pages.standards.messageType.colStatus': '状态',
  'pages.standards.messageType.colTestResult': '最近测试结果',
  'pages.standards.messageType.colUpdatedAt': '更新时间',
  'pages.standards.messageType.direction.inbound': '入站 (Inbound)',
  'pages.standards.messageType.direction.outbound': '出站 (Outbound)',
  'pages.standards.messageType.status.draft': '草稿',
  'pages.standards.messageType.status.testing': '测试中',
  'pages.standards.messageType.status.published': '已发布',
  'pages.standards.messageType.testResult.passed': '通过 (Passed)',
  'pages.standards.messageType.testResult.failed': '失败 (Failed)',
  'pages.standards.messageType.testResult.untested': '未测试 (Untested)',
  'pages.standards.messageType.cannotPublishTip':
    '最近测试结果为失败或未测试，不允许发布！请先通过样例测试',
  'pages.standards.messageType.publish': '发布',
  'pages.standards.messageType.publishSuccess': '报文类型已发布生效',
  'pages.standards.messageType.emptyDesc': '暂无报文类型，请先创建报文类型',
  'pages.standards.messageType.copySuccess': '规则已复制',
  'pages.standards.messageType.migrateModalTitle': '批量版本迁移',
  'pages.standards.messageType.migrateSourceStd': '原标准版本',
  'pages.standards.messageType.migrateTargetStd': '目标升级版本',
  'pages.standards.messageType.migrateNotice':
    '迁移后将生成新版本规则并保留回滚入口，需通过回归样例测试后方可发布。',
  'pages.standards.messageType.migrateSuccess':
    '版本迁移任务已启动并生成新版草稿',
  'pages.standards.messageType.createSuccess': '新建报文类型成功',

  // P-09 映射设计器
  'pages.standards.mappingDesigner.title': '映射设计器',
  'pages.standards.mappingDesigner.desc':
    '源字段树、映射连线画布与目标字段树三栏配置，含样例试跑与必填字段映射阻断。',

  // P-10 码值字典
  'pages.standards.dictionaries.title': '码值字典管理',
  'pages.standards.dictionaries.desc':
    '维护港口代码、箱型代码、币种等公共码值，配置针对交易伙伴的一对多内外部对照。',
  'pages.standards.dict.title': '码值字典管理',
  'pages.standards.dict.desc':
    '维护港口代码、箱型代码、币种等公共码值，配置针对交易伙伴的一对多内外部对照。',
  'pages.standards.dict.categoryTree': '字典分类目录',
  'pages.standards.dict.categoryPorts': '港口代码表 (UN/LOCODE)',
  'pages.standards.dict.categoryCntrs': '集装箱箱型代码 (ISO 6346)',
  'pages.standards.dict.categoryCurrencies': '国际货币代码 (ISO 4217)',
  'pages.standards.dict.categoryUnits': '计量单位代码 (UNECE Rec 20)',
  'pages.standards.dict.categoryCarriers': '船公司代码 (SCAC / Carrier)',
  'pages.standards.dict.create': '新增码值',
  'pages.standards.dict.import': '批量导入',
  'pages.standards.dict.export': '导出字典',
  'pages.standards.dict.colInternalCode': '内部码值',
  'pages.standards.dict.colInternalName': '内部名称',
  'pages.standards.dict.colExternalCodes': '外部码值对照 (一对多)',
  'pages.standards.dict.colStandard': '标准来源',
  'pages.standards.dict.colStatus': '状态',
  'pages.standards.dict.colUpdatedAt': '更新时间',
  'pages.standards.dict.filterPartner': '按交易伙伴筛选外部码值',
  'pages.standards.dict.allPartners': '全部交易伙伴',
  'pages.standards.dict.references': '查看引用',
  'pages.standards.dict.referencesTitle': '码值对照与引用',
  'pages.standards.dict.referencesDesc':
    '当前码值被以下报文类型的基线映射引用：',
  'pages.standards.dict.emptyDesc': '暂无码值对照记录，请新增或批量导入',
  'pages.standards.dict.createSuccess': '码值对照记录创建成功',
  'pages.standards.dict.importSuccess': '批量导入任务已提交',
  'pages.standards.dict.exportNotice':
    '字典导出任务已创建，完成后在通知中心下载',
  'pages.standards.dict.oneToManyDesc':
    '支持一个内部码值对应多个交易伙伴不同的外部编码，转换引擎按当前通信主体自动解析。',

  // P-11 报文查询
  'pages.messages.status.delivered': '已投递',
  'pages.messages.status.sent': '已发送',
  'pages.messages.status.processed': '已处理（未投递）',
  'pages.messages.status.failed': '失败',
  'pages.messages.status.duplicate': '重复',
  'pages.messages.title': '报文查询',
  'pages.messages.desc':
    '高频查询出入站报文，支持高级多维度筛选、正交双维度状态展示、批量重处理与异步导出。',
  'pages.messages.query.filterTitle': '高级多维筛选',
  'pages.messages.query.direction': '报文方向',
  'pages.messages.query.allDirections': '全部方向',
  'pages.messages.query.inbound': '入站 (INBOUND)',
  'pages.messages.query.outbound': '出站 (OUTBOUND)',
  'pages.messages.query.partner': '交易伙伴',
  'pages.messages.query.allPartners': '全部主体',
  'pages.messages.query.msgType': '报文类型',
  'pages.messages.query.msgId': '报文编号',
  'pages.messages.query.msgIdPlaceholder': '支持输入完整或前缀编号',
  'pages.messages.query.docNo': '业务单号',
  'pages.messages.query.docNoPlaceholder': '订单号 / 提单号 / 箱号 (模糊匹配)',
  'pages.messages.query.processStatus': '处理状态',
  'pages.messages.query.transportAck': '传输回执',
  'pages.messages.query.syntaxAck': '语法回执',
  'pages.messages.query.appAck': '应用回执',
  'pages.messages.query.allAcks': '全部',
  'pages.messages.query.timeRange': '传输时间范围',
  'pages.messages.query.hasError': '是否有异常',
  'pages.messages.query.hasErrorYes': '仅看异常报文',
  'pages.messages.query.hasErrorNo': '仅看正常报文',
  'pages.messages.query.isReplay': '是否重处理生成',
  'pages.messages.query.isReplayYes': '仅看重处理',
  'pages.messages.query.isReplayNo': '排除重处理',
  'pages.messages.query.col.msgId': '报文编号',
  'pages.messages.query.col.direction': '方向',
  'pages.messages.query.col.partner': '交易伙伴',
  'pages.messages.query.col.msgType': '报文类型',
  'pages.messages.query.col.docNo': '业务单号',
  'pages.messages.query.col.status': '双维度正交状态',
  'pages.messages.query.col.attempt': '尝试',
  'pages.messages.query.col.transferTime': '传输时间',
  'pages.messages.query.col.duration': '耗时',
  'pages.messages.query.replayTag': '重放',
  'pages.messages.query.batchReplay': '批量重处理',
  'pages.messages.query.batchResend': '批量补发',
  'pages.messages.query.batchPrecheckTitle': '批量操作预检结果确认',
  'pages.messages.query.batchPrecheckDesc':
    '将对选中的 {total} 条报文执行操作：其中 {eligible} 条满足处理条件，{skipped} 条不满足条件将被跳过。',
  'pages.messages.query.exportAsyncTitle': '导出报文查询结果',
  'pages.messages.query.exportAsyncNotice':
    '导出任务已创建（任务编号: {taskId}），数据生成完成后系统将在通知中心提醒您下载。',
  'pages.messages.query.downloadRaw': '下载原文',
  'pages.messages.query.viewDetail': '查看详情',
  'pages.messages.query.selectedCount': '已选中 {count} 条报文',

  // P-13 单号追溯
  'pages.messages.documents.title': '单号追溯',
  'pages.messages.documents.desc':
    '按订舱单号/提单号聚合全生命周期报文交互链条，展示单据状态与截单时效告警。',

  // P-12 报文详情
  'pages.messages.detail.title': '报文详情',
  'pages.messages.detail.desc':
    '只读处理尝试时间线（显式区分历史尝试只读与当前尝试），提供原始报文、转换对照、校验分组与回执详情。',
  'pages.messages.detail.msgId': '报文编号',
  'pages.messages.detail.direction': '传输方向',
  'pages.messages.detail.partner': '交易伙伴',
  'pages.messages.detail.msgType': '报文类型',
  'pages.messages.detail.docNo': '业务单号',
  'pages.messages.detail.summaryHash': '摘要哈希',
  'pages.messages.detail.transferTime': '传输时间',
  'pages.messages.detail.duration': '总耗时',
  'pages.messages.detail.currentAttempt': '当前尝试号',
  'pages.messages.detail.replayGeneratedTag': '重处理产生',
  'pages.messages.detail.rawNoContent': '无原始报文材料',
  'pages.messages.detail.imoSolasCompliant': 'IMO SOLAS 合规',
  'pages.messages.detail.relations.iftmbc': 'IFTMBC (订舱申请)',
  'pages.messages.detail.relations.confirmed': '已确认',
  'pages.messages.detail.relations.iftmin': 'IFTMIN (订舱变更申请)',
  'pages.messages.detail.relations.current': '当前',
  'pages.messages.detail.relations.vermas': 'VERMAS (箱称重申报)',
  'pages.messages.detail.relations.pendingSend': '待发',
  'pages.messages.detail.btn.replay': '重处理',
  'pages.messages.detail.btn.resend': '补发',
  'pages.messages.detail.btn.download': '下载原始报文',
  'pages.messages.detail.btn.createWorkorder': '创建工单',
  'pages.messages.detail.timeline.title':
    '处理尝试时间线 (历史尝试只读不可篡改)',
  'pages.messages.detail.timeline.readOnlyTag': '只读历史',
  'pages.messages.detail.timeline.currentTag': '当前',
  'pages.messages.detail.timeline.attemptTitle': '尝试 {no}',
  'pages.messages.detail.timeline.stepDesc':
    '耗时 {ms}ms | 标准: {std} | 映射: {map}',
  'pages.messages.detail.timeline.errorInfo': '错误代码: {code} | 原因: {msg}',
  'pages.messages.detail.tab.raw': '原始报文',
  'pages.messages.detail.tab.rawText': '原始纯文本视图',
  'pages.messages.detail.tab.rawSegments': '分段高亮对照视图',
  'pages.messages.detail.tab.transform': '转换结果结构化视图',
  'pages.messages.detail.tab.validation': '合规校验结果',
  'pages.messages.detail.tab.receipts': '多层回执详情',
  'pages.messages.detail.tab.relations': '关联报文 (版本单据链)',
  'pages.messages.detail.tab.audit': '操作审计记录',
  'pages.messages.detail.modal.replayTitle': '重处理报文确认',
  'pages.messages.detail.modal.replayDesc':
    '本次重处理将在不可变历史时间线上创建新尝试节点（尝试号将自增），不会更新或覆盖历史尝试结果。',
  'pages.messages.detail.modal.resendTitle': '补发报文确认',
  'pages.messages.detail.modal.resendDesc':
    '系统已对对端进行幂等键校验。将通过传输通道重新发送报文材料，并开启回执超时计时。',
  'pages.messages.detail.modal.reason': '操作原因与审批依据',
  'pages.messages.detail.modal.reasonPlaceholder':
    '请输入本次操作的业务原因或工单单号',
  'pages.messages.detail.modal.standardVersion': '选择使用的标准版本快照',
  'pages.messages.detail.modal.modifyPayload': '是否手工修正报文内容后重放',

  // P-14 预警事件
  'pages.alerts.events.title': '预警事件',
  'pages.alerts.events.desc':
    '实时展示并聚合同一去重键的高频预警事件，支持折叠发生频次与快捷认领转工单。',

  // P-15 预警规则
  'pages.alerts.rules.title': '预警规则管理',
  'pages.alerts.rules.desc':
    '配置传输异常、校验阻断与船司截单时效监控规则，支持噪音规则高频告警提示。',

  // P-16 异常工单
  'pages.alerts.workorders.title': '异常工单',
  'pages.alerts.workorders.desc':
    '异常排查工单闭环流转，展示 SLA 倒计时与追加式不可编辑处理过程。',

  // P-17 样例报文库

  // P-18 对端模拟器

  // P-19 报文诊断

  // P-20 操作审计
  'pages.audit.logs.title': '操作审计',
  'pages.audit.logs.desc':
    '全量记录管理员与运维人员的操作行为，行展开提供前后数据对比（Diff）视图。',
  'pages.audit.logs.bannerTitle': '审计日志不可篡改保证与完整性校验状态',
  'pages.audit.logs.bannerDesc':
    '本系统全部操作日志采用 WORM (Write Once, Read Many) 存储与密码学哈希链校验，最近锚定校验：通过（不可删除、不可修改）。',
  'pages.audit.logs.colTime': '操作时间',
  'pages.audit.logs.colOperator': '操作人',
  'pages.audit.logs.colOrg': '所属组织',
  'pages.audit.logs.colType': '操作类型',
  'pages.audit.logs.colTarget': '操作对象',
  'pages.audit.logs.colIp': '终端 IP',
  'pages.audit.logs.colResult': '操作结果',
  'pages.audit.logs.colHash': '完整性状态',
  'pages.audit.logs.hashVerified': '哈希链校验通过',
  'pages.audit.logs.hashFailed': '哈希校验异常',
  'pages.audit.logs.diffTitle': '操作前后数据对比 (Diff 视图)',
  'pages.audit.logs.diffBefore': '变更前数据 (Before)',
  'pages.audit.logs.diffAfter': '变更后数据 (After)',
  'pages.audit.logs.diffNoData': '该操作未产生前后数据快照',
  'pages.audit.logs.emptyText': '暂无操作审计日志记录',
  'pages.audit.logs.filterTime': '操作时间范围',
  'pages.audit.logs.filterOperator': '操作人姓名 / 账号',
  'pages.audit.logs.filterType': '操作类型',
  'pages.audit.logs.filterResult': '操作结果',
  'pages.audit.logs.immutableNotice':
    '审计日志永久只读归档，系统未提供任何删除入口。',

  // P-21 审计报表
  'pages.audit.reports.title': '审计报表',
  'pages.audit.reports.desc':
    '配置定时报表生成模板，导出收发统计、时效达成、合规校验与安全审计报表。',
  'pages.audit.reports.tabTemplates': '报表模板列表',
  'pages.audit.reports.tabGenerated': '已生成报表列表',
  'pages.audit.reports.createTemplateBtn': '新建报表模板',
  'pages.audit.reports.colTplName': '模板名称',
  'pages.audit.reports.colTplType': '报表类型',
  'pages.audit.reports.colTplPeriod': '调度周期',
  'pages.audit.reports.colTplScope': '统计范围',
  'pages.audit.reports.colTplRecipients': '接收人邮箱',
  'pages.audit.reports.colTplStatus': '模板状态',
  'pages.audit.reports.actionGenerateNow': '立即生成一次',
  'pages.audit.reports.actionEdit': '编辑模板',
  'pages.audit.reports.generateTaskNotice':
    '报表异步生成任务已创建，系统将在后台执行并在通知中心提醒您下载。',
  'pages.audit.reports.colGenName': '报表文件名称',
  'pages.audit.reports.colGenPeriod': '报表周期',
  'pages.audit.reports.colGenTime': '生成完成时间',
  'pages.audit.reports.colGenRange': '数据区间',
  'pages.audit.reports.colGenFormat': '文件格式',
  'pages.audit.reports.colGenSize': '文件大小',
  'pages.audit.reports.actionDownload': '下载文件',
  'pages.audit.reports.downloadNotice': '报表文件下载任务已触发，请稍候。',
  'pages.audit.reports.emptyTemplates': '暂无配置报表模板',
  'pages.audit.reports.emptyTemplatesAction': '新建首个报表模板',
  'pages.audit.reports.emptyGenerated': '暂无已生成的报表文件',
  'pages.audit.reports.modalTitle': '新建报表模板',
  'pages.audit.reports.modalName': '模板名称',
  'pages.audit.reports.modalType': '报表类型',
  'pages.audit.reports.modalPeriod': '统计周期',
  'pages.audit.reports.modalScope': '统计范围',
  'pages.audit.reports.modalRecipients': '接收邮箱 (逗号分隔)',
  'pages.audit.reports.createSuccess': '报表模板创建成功',
  'pages.audit.reports.typeStats': '报文收发统计与时效监控',
  'pages.audit.reports.typeErrors': '异常分析与 SLA 报表',
  'pages.audit.reports.typeAudit': '操作日志与安全审计',
  'pages.audit.reports.typeCompliance': '合规与规则校验分析',
  'pages.audit.reports.periodDaily': '每日 (Daily)',
  'pages.audit.reports.periodWeekly': '每周 (Weekly)',
  'pages.audit.reports.periodMonthly': '每月 (Monthly)',
  'pages.audit.reports.periodQuarterly': '每季 (Quarterly)',

  'pages.standards.library.uploadText':
    '点击或将标准架构定义文件 (XSD / JSON Schema / EDIFACT DEF) 拖拽到此处',
  'pages.standards.library.uploadHint':
    '支持 UN/EDIFACT 目录文件、GB/T 标准规范描述及自定义结构包',
  'pages.standards.library.baseVersion': '基线版本',
  'pages.standards.library.newVersion': '新派生版本号',
  'pages.standards.library.versionNotes': '版本变更说明',
  'pages.standards.library.versionNotesPlaceholder':
    '请说明基于基线版本所做的扩展与调整项...',
  'pages.standards.library.importSuccess': '标准定义文件解析成功并导入',
  'pages.standards.library.diffBase': '对比基准',
  'pages.standards.library.newVersionPlaceholder': '例如 D.22B 或 v2.1',
  'pages.standards.detail.segment': '段 (Segment)',
  'pages.standards.detail.segmentGroup': '段组 (Segment Group)',
  'pages.standards.detail.composite': '复合数据元素 (Composite)',
  'pages.standards.detail.element': '数据元素 (Data Element)',
  'pages.standards.detail.selectNodeTip':
    '请在左侧树结构中选择节点以查看和编辑属性',
  'pages.standards.detail.diffTitle': '与其他版本差异对比',
  'pages.standards.detail.diffComparedVersion': '对比版本',
  'pages.standards.detail.ruleName': '规则名称',
  'pages.standards.detail.ruleType': '校验类型',
  'pages.standards.detail.ruleDesc': '规则描述',
  'pages.standards.dict.categoryAll': '全部类别',
  'pages.standards.dict.importModalTitle': '批量导入码值字典 (Excel)',
  'pages.standards.dict.uploadFileTip':
    '点击或拖拽 Excel 文件 (.xlsx, .xls) 到此处导入',
  'pages.standards.dict.uploadFileHint':
    '支持内部码值与外部交易伙伴码值多列映射格式',
  'pages.standards.dict.sampleRefRule': '马士基订舱确认映射 (map-01)',
  'pages.standards.dict.edit': '编辑',

  'pages.standards.detail.typeAn': 'AN (字母数字)',
  'pages.standards.detail.typeN': 'N (数值型)',
  'pages.standards.detail.noDict': '无绑定字典',

  'pages.standards.messageType.migrateOption1':
    'UN/EDIFACT IFTMBC D.99B (当前关联 2 条规则)',
  'pages.standards.messageType.migrateOption2':
    'UN/EDIFACT IFTMBF D.00B (当前关联 1 条规则)',
  'pages.standards.messageType.migrateTargetOption1':
    'UN/EDIFACT IFTMBC D.00B (最新已发布)',
  'pages.standards.messageType.migrateTargetOption2':
    'UN/EDIFACT IFTMBF D.21A (最新草稿)',

  'pages.standards.dict.samplePartnerCosco': '中远海运',
  'pages.standards.dict.colRefRule': '映射转换规则',
  'pages.standards.dict.colBoundField': '绑定字段',
  'pages.standards.dict.colMapFunction': '映射函数',

  // P-13 单号追溯
  'pages.messages.documents.disclaimerTitle': '业务时序待澄清事项提醒',
  'pages.messages.documents.disclaimerDesc':
    '本页业务时序为海运常规示意（订舱申请→确认→变更→SI补料→VGM→提单确认→箱动态），具体交互规则需业务方进一步确认（功能清单第十章第 1 条待澄清事项）。',
  'pages.messages.documents.searchLabel': '业务单号',
  'pages.messages.documents.searchPlaceholder': '请输入订舱单号或提单号',
  'pages.messages.documents.searchBtn': '查询单据',
  'pages.messages.documents.resetBtn': '重置',
  'pages.messages.documents.quickSampleBtn': '加载退关全版本链样例 (超长单号)',
  'pages.messages.documents.docInfoTitle': '单据当前状态与核心字段',
  'pages.messages.documents.businessDocNo': '业务单号',
  'pages.messages.documents.businessType': '业务类型',
  'pages.messages.documents.carrierName': '承运人 / 交易伙伴',
  'pages.messages.documents.vesselVoyage': '船名航次',
  'pages.messages.documents.portOfLoading': '启运港 (POL)',
  'pages.messages.documents.portOfDischarge': '目的港 (POD)',
  'pages.messages.documents.containerSummary': '箱量箱型与货重',
  'pages.messages.documents.cutoffMonitoringTitle': '船司截单时效监控 (M5-07)',
  'pages.messages.documents.siCutoff': 'SI 截补料时间',
  'pages.messages.documents.vgmCutoff': 'VGM 截申报时间',
  'pages.messages.documents.customsCutoff': '海关截放行时间',
  'pages.messages.documents.cutoffWarningTitle':
    '截单临近告警：存在未完成的必填业务动作',
  'pages.messages.documents.cutoffWarningDesc':
    '单据已申请退关且已核准，截单时效倒计时已归档终止。若为正常未截单单据，距截单不足 180 分钟将触发红色高亮阻断。',
  'pages.messages.documents.timelineTitle': '全生命周期交互时序与报文轨迹',
  'pages.messages.documents.viewMessageDetail': '查看报文详情',
  'pages.messages.documents.inboundTag': '入站',
  'pages.messages.documents.outboundTag': '出站',
  'pages.messages.documents.versionLabel': '报文版本',
  'pages.messages.documents.noteLabel': '处理备注',
  'pages.messages.documents.emptyText': '未查到对应单号的追溯轨迹',
  'pages.messages.documents.statusBooked': '已订舱确认',
  'pages.messages.documents.statusAmended': '已变更',
  'pages.messages.documents.statusCancelled': '已退关取消',

  // P-14 预警事件
  'pages.alerts.events.colEventNo': '事件编号',
  'pages.alerts.events.colLevel': '预警级别',
  'pages.alerts.events.colRuleName': '规则名称',
  'pages.alerts.events.colType': '预警类型',
  'pages.alerts.events.colPartner': '交易伙伴',
  'pages.alerts.events.colMessage': '关联报文',
  'pages.alerts.events.colTriggeredAt': '触发时间',
  'pages.alerts.events.colDuration': '持续时长',
  'pages.alerts.events.colStatus': '状态',
  'pages.alerts.events.colAssignee': '处理人',
  'pages.alerts.events.colDedupCount': '去重合并统计',
  'pages.alerts.events.colAction': '操作',
  'pages.alerts.events.levelCritical': '紧急',
  'pages.alerts.events.levelHigh': '高',
  'pages.alerts.events.levelMedium': '中',
  'pages.alerts.events.levelLow': '低',
  'pages.alerts.events.typeTransport': '传输异常',
  'pages.alerts.events.typeValidation': '校验异常',
  'pages.alerts.events.typeSystem': '系统异常',
  'pages.alerts.events.typeSla': '时效异常',
  'pages.alerts.events.statusUnhandled': '未处理',
  'pages.alerts.events.statusHandling': '处理中',
  'pages.alerts.events.statusResolved': '已恢复',
  'pages.alerts.events.statusIgnored': '已忽略',
  'pages.alerts.events.claimBtn': '认领',
  'pages.alerts.events.claimSuccess': '预警认领成功，状态已转为处理中',
  'pages.alerts.events.ignoreBtn': '忽略',
  'pages.alerts.events.ignoreModalTitle': '忽略预警事件',
  'pages.alerts.events.ignoreReasonLabel': '忽略原因',
  'pages.alerts.events.ignoreReasonPlaceholder': '请填写忽略原因（必填）',
  'pages.alerts.events.ignoreSuccess': '预警事件已标记为已忽略',
  'pages.alerts.events.toWorkorderBtn': '转工单',
  'pages.alerts.events.toWorkorderSuccess': '已基于预警事件成功创建工单',
  'pages.alerts.events.viewRule': '查看规则',
  'pages.alerts.events.foldedTag': '聚合折叠 {count} 次',
  'pages.alerts.events.expandDedupKey': '去重键 (Dedup Key)',
  'pages.alerts.events.filterAll': '全部状态',
  'pages.alerts.events.filterDefaultView': '默认活跃预警 (未处理/处理中)',
  'pages.alerts.events.empty': '暂无符合条件的预警事件',

  // P-15 预警规则
  'pages.alerts.rules.createBtn': '新建预警规则',
  'pages.alerts.rules.colName': '规则名称',
  'pages.alerts.rules.colScenario': '预警场景',
  'pages.alerts.rules.colTriggerMode': '触发方式',
  'pages.alerts.rules.triggerEvent': '事件触发',
  'pages.alerts.rules.triggerScheduled': '时效检测',
  'pages.alerts.rules.triggerEventTip':
    '交换引擎产生解析、校验、映射或传输异常事件时实时触发',
  'pages.alerts.rules.triggerScheduledTip':
    '根据回执时限或业务日历持续检测，达到时间条件后触发',
  'pages.alerts.rules.colCondition': '触发条件摘要',
  'pages.alerts.rules.colNotifyChannels': '通知方式',
  'pages.alerts.rules.colNotifyTargets': '通知对象',
  'pages.alerts.rules.colSilentWindow': '静默窗口',
  'pages.alerts.rules.colStatus': '状态',
  'pages.alerts.rules.colLastTriggered': '最近触发时间',
  'pages.alerts.rules.col7dCount': '近 7 天触发次数',
  'pages.alerts.rules.colAction': '操作',
  'pages.alerts.rules.editBtn': '编辑',
  'pages.alerts.rules.noiseWarningTag': '噪音过高：建议调整阈值',
  'pages.alerts.rules.noiseWarningTooltip':
    '近 7 天累计触发 {count} 次，告警频率异常高，可能是阈值过于激进，建议适度调宽或增加静默窗口以降低告警疲劳。',
  'pages.alerts.rules.minutesUnit': '{val} 分钟',
  'pages.alerts.rules.modalCreateTitle': '新建预警规则',
  'pages.alerts.rules.modalEditTitle': '编辑预警规则',
  'pages.alerts.rules.sectionBase': '基础信息与触发条件',
  'pages.alerts.rules.sectionSlaSpecial':
    '时效类规则专项配置 (M5-07 截单时钟与日历)',
  'pages.alerts.rules.sectionNotify': '静默窗口与通知',
  'pages.alerts.rules.fieldScenario': '预警场景',
  'pages.alerts.rules.fieldName': '规则名称',
  'pages.alerts.rules.fieldCondition': '触发条件表达式',
  'pages.alerts.rules.fieldDedupKey': '去重键模板',
  'pages.alerts.rules.fieldSilent': '静默窗口 (分钟)',
  'pages.alerts.rules.fieldChannels': '通知渠道',
  'pages.alerts.rules.fieldTargets': '通知对象',
  'pages.alerts.rules.fieldEscalation': '升级路径',
  'pages.alerts.rules.fieldRecovery': '自动恢复条件',
  'pages.alerts.rules.fieldCalendar': '截单工作日历',
  'pages.alerts.rules.fieldTimezone': '基准时区',
  'pages.alerts.rules.fieldAdvanceWindow': '提前预警窗口 (分钟)',
  'pages.alerts.rules.saveSuccess': '预警规则保存成功',
  'pages.alerts.rules.toggleSuccess': '规则状态已更新',
  'pages.alerts.rules.empty': '暂无预警规则，点击新建',
  'pages.alerts.rules.optScenario1': '出站传输通道监控',
  'pages.alerts.rules.optScenario2': '入站报文解析',
  'pages.alerts.rules.optScenario3': '业务截单日历时效监控',
  'pages.alerts.rules.optScenario4': '报文必填元素语法校验',
  'pages.alerts.rules.optTzUtc': 'UTC (格林威治标准时间)',

  // P-16 异常工单
  'pages.alerts.workorders.createBtn': '新建工单',
  'pages.alerts.workorders.colNo': '工单号',
  'pages.alerts.workorders.colTitle': '工单标题',
  'pages.alerts.workorders.colSource': '来源',
  'pages.alerts.workorders.colRelated': '关联报文 / 事件',
  'pages.alerts.workorders.colPriority': '优先级',
  'pages.alerts.workorders.colAssignee': '处理人',
  'pages.alerts.workorders.colStatus': '工单状态',
  'pages.alerts.workorders.colCreatedAt': '创建时间',
  'pages.alerts.workorders.colSlaRemaining': 'SLA 剩余时间',
  'pages.alerts.workorders.colDuration': '处理时长',
  'pages.alerts.workorders.colAction': '操作',
  'pages.alerts.workorders.slaOverdueTag': '已超时 {min} 分钟',
  'pages.alerts.workorders.slaWarningTag': '仅剩 {min} 分钟 (即将超时)',
  'pages.alerts.workorders.slaNormalTag': '剩余 {min} 分钟',
  'pages.alerts.workorders.sourceAuto': '预警自动生成',
  'pages.alerts.workorders.sourceManual': '人工创建',
  'pages.alerts.workorders.statusPendingAssign': '待分派',
  'pages.alerts.workorders.statusProcessing': '处理中',
  'pages.alerts.workorders.statusPendingVerify': '待验证',
  'pages.alerts.workorders.statusClosed': '已关闭',
  'pages.alerts.workorders.viewDetailBtn': '工单详情',
  'pages.alerts.workorders.drawerTitle': '工单详情与处理轨迹',
  'pages.alerts.workorders.baseInfoCard': '基本信息',
  'pages.alerts.workorders.relatedObjectCard': '关联对象',
  'pages.alerts.workorders.historyNotice':
    '历史记录为不可篡改审计追踪项，仅支持以当前操作者身份追加最新处理记录。',
  'pages.alerts.workorders.appendRecordBtn': '追加处理记录',
  'pages.alerts.workorders.appendPlaceholder':
    '请输入本次排查进展、与对端沟通结论或修复动作...',
  'pages.alerts.workorders.appendSuccess': '处理记录追加成功',
  'pages.alerts.workorders.closeBtn': '关闭工单',
  'pages.alerts.workorders.closeModalTitle': '关闭工单 (必填关闭依据)',
  'pages.alerts.workorders.closeReasonLabel': '关闭依据与根因分析',
  'pages.alerts.workorders.closeReasonPlaceholder':
    '请详细填写工单关闭依据、根本原因及后续防范措施（必填）',
  'pages.alerts.workorders.closeSuccess': '工单已成功关闭',
  'pages.alerts.workorders.empty': '暂无工单数据',
  'pages.alerts.workorders.optP0': 'P0 (最高)',
  'pages.alerts.workorders.optP1': 'P1 (高)',
  'pages.alerts.workorders.optP2': 'P2 (中)',
  'pages.alerts.workorders.optP3': 'P3 (低)',
  'pages.alerts.workorders.slaOverdueAlertDesc':
    '本工单已超过处理时限，请尽快排查并关闭；需要升级时请在处理记录中说明并联系负责人。',
  'pages.alerts.workorders.slaWarningAlertDesc':
    '工单临近 SLA 预警红线，请加紧推进故障定界。',

  // P-09 映射转换方式补充

  // P-08 版本迁移差异预览
  'pages.standards.messageType.diffTitle': '版本字段级差异对照与影响规则预览',
  'pages.standards.messageType.affectedRulesCount': '本批将影响 2 条规则',
  'pages.standards.messageType.diffColType': '变更类型',
  'pages.standards.messageType.diffColField': '字段编码与名称',
  'pages.standards.messageType.diffColOld': '旧版规格 (D.99B)',
  'pages.standards.messageType.diffColNew': '新版规格 (D.00B)',
  'pages.standards.messageType.diffColImpact': '规则影响评估',
  'pages.standards.messageType.rollbackReadyNote':
    '已自动就绪回滚快照点 SNAP-20260920-V2，迁移后保留一键回滚入口。',
  'pages.standards.messageType.migrateSourcePlaceholder':
    '请选择需升级的基线版本',
  'pages.standards.messageType.migrateTargetPlaceholder': '请选择目标升级版本',

  // P-11 报文查询模拟标记与筛选
  'pages.messages.query.simulatedTag': '模拟',
  'pages.messages.query.includeSimulated': '包含模拟报文',
  'pages.messages.query.collapseFilter': '收起高级筛选 ▲',
  'pages.messages.query.expandFilter': '展开高级筛选 ▼',
  'pages.messages.query.summaryHashLabel': '摘要: ',

  // P-12 补发弹窗与关联
  'pages.messages.detail.modal.targetPartner': '接收方交易伙伴',
  'pages.messages.detail.modal.idempotencyResult': '幂等检查结果',
  'pages.messages.detail.modal.idempotencyPassed': '通过校验',
  'pages.messages.detail.modal.idempotencyDetail':
    '幂等校验键（Message-ID: {msgId}）已比对，未触发防重放冲突，允许安全重试补发。',
  'pages.messages.detail.modal.receiverAckPolicy': '接收方回执策略',
  'pages.messages.detail.modal.transportAckLabel': '传输回执: ',
  'pages.messages.detail.modal.syntaxAckLabel': '语法回执: ',
  'pages.messages.detail.modal.appAckLabel': '应用回执: ',
  'pages.messages.detail.modal.timeoutMins': '已声明 (超时 {minutes} 分钟)',
  'pages.messages.detail.modal.notDeclared': '未声明',
  'pages.messages.detail.modal.lastSendInfo': '上次发送时间与结果',
  'pages.messages.detail.modal.reasonRequired': '请输入补发原因',
  'pages.messages.detail.modal.createWorkorderTitle': '创建异常排查工单',
  'pages.messages.detail.modal.defaultWorkorderTitle': '排查报文异常 {msgId}',
  'pages.messages.detail.modal.workorderSuccessWithNo':
    '已成功创建工单 {no} 并分派专人处理',
  'pages.messages.detail.modal.workorderSuccess':
    '已成功创建工单并分派专人处理',
  'pages.messages.detail.modal.createNow': '立即创建',
  'pages.messages.detail.modal.relatedMessageLabel': '关联报文: ',
  'pages.messages.detail.modal.workorderTitlePlaceholder': '工单标题',
  'pages.messages.detail.relations.alertTitle':
    '本单据完整生命周期报文交互链条',
  'pages.messages.detail.relations.alertDesc':
    '业务单号 {docNo} 包含全流程交互记录。点击可直接跳转到单号追溯。',
  'pages.messages.detail.relations.traceBtn': '追溯详情',
  'pages.messages.detail.parentBatchTitle': '所属批量父报文关联',
  'pages.messages.detail.parentBatchDesc':
    '本报文由复合批量报文拆分生成，所属批次:',
  'pages.messages.detail.childBatchTitle': '批量合批包含的子报文关联',
  'pages.messages.detail.childBatchDesc':
    '本批量报文包含以下独立子报文，可直接点击跳转查看处理轨迹：',

  // P-22 批量报文处理
  'pages.messages.batch.title': '批量报文处理',
  'pages.messages.batch.desc':
    '支持出站多票业务单据合批打包与入站复合报文拆分解耦，校验标准与版本一致性，维护完整父子关联与操作留痕。',
  'pages.messages.batch.tabOutbound': '出站合并 (Aggregation)',
  'pages.messages.batch.tabInbound': '入站拆分 (Splitting)',
  'pages.messages.batch.tabHistory': '批次处理列表 (Batch Records)',
  'pages.messages.batch.outboundNoticeTitle': '出站合批打包规则说明',
  'pages.messages.batch.outboundNoticeDesc':
    '系统按接收方主体、报文类型和基线版本进行一致性校验。只有接收方与标准版本完全一致的业务单据方可纳入同一批次生成批量出站报文。',
  'pages.messages.batch.candidateListTitle': '待发送业务单据池',
  'pages.messages.batch.selectedCount': '已勾选 {count} 票',
  'pages.messages.batch.btnPreviewMerge': '预览合并批次',
  'pages.messages.batch.partnerMismatch':
    '接收方交易伙伴不一致！批量合并要求同一批次内的所有报文必须送往同一接收主体。',
  'pages.messages.batch.versionMismatch':
    '标准基线版本不一致！同一合并批次内必须使用完全相同的标准版本。',
  'pages.messages.batch.mergeSuccess': '出站批量报文合并成功并已进入发送流程',
  'pages.messages.batch.inboundNoticeTitle': '入站复合报文拆分说明',
  'pages.messages.batch.inboundNoticeDesc':
    '接收到的包含多票业务单据的复合报文可在此执行解耦拆分。拆分后的子报文独立进入校验转换链路，并与父报文批次建立双向关联。',
  'pages.messages.batch.selectInboundBatch': '选择待拆分入站报文:',
  'pages.messages.batch.btnSplitSelected': '拆分所选子报文 ({count})',
  'pages.messages.batch.btnSplitAll': '整批全部拆分',
  'pages.messages.batch.splitSuccess':
    '入站批量报文拆分成功，已建立父子双向关联',
  'pages.messages.batch.batchMetaTitle': '父报文信息与子单据明细',
  'pages.messages.batch.totalSubTag': '包含 {count} 票单据',
  'pages.messages.batch.metaPartner': '发送主体',
  'pages.messages.batch.metaVersion': '标准版本',
  'pages.messages.batch.metaTime': '接收时间',
  'pages.messages.batch.emptyInbound': '暂无可拆分的入站批量报文',
  'pages.messages.batch.batchRecordsTitle': '批量合拆留痕记录表',
  'pages.messages.batch.subMessagesOverview': '包含子报文明细 (点击跳转详情):',
  'pages.messages.batch.ticketsUnit': '票',
  'pages.messages.batch.col.docNo': '业务单号',
  'pages.messages.batch.col.partner': '接收方交易伙伴',
  'pages.messages.batch.col.msgType': '报文类型',
  'pages.messages.batch.col.stdVersion': '标准版本',
  'pages.messages.batch.col.size': '预估大小',
  'pages.messages.batch.col.createdAt': '待发生成时间',
  'pages.messages.batch.col.status': '状态',
  'pages.messages.batch.statusPending': '待合并',
  'pages.messages.batch.statusBatched': '已合并封包',
  'pages.messages.batch.list.batchNo': '批次编号',
  'pages.messages.batch.list.direction': '方向',
  'pages.messages.batch.outboundTag': '出站合并',
  'pages.messages.batch.inboundTag': '入站拆分',
  'pages.messages.batch.list.partner': '交易伙伴',
  'pages.messages.batch.list.msgType': '报文类型',
  'pages.messages.batch.list.controlNo': '交换控制号',
  'pages.messages.batch.list.subCount': '子报文票数',
  'pages.messages.batch.list.size': '报文大小',
  'pages.messages.batch.list.time': '处理时间',
  'pages.messages.batch.list.operator': '操作人',
  'pages.messages.batch.list.status': '处理状态',
  'pages.messages.batch.statusCompleted': '处理成功',
  'pages.messages.batch.subCol.msgId': '子报文编号',
  'pages.messages.batch.subCol.docNo': '业务单号',
  'pages.messages.batch.subCol.msgType': '报文类型',
  'pages.messages.batch.subCol.validation': '解析校验结果',
  'pages.messages.batch.valSuccess': '校验通过',
  'pages.messages.batch.valWarn': '告警放行',
  'pages.messages.batch.subCol.size': '子报文大小',
  'pages.messages.batch.modal.mergeTitle': '出站批量报文封包确认',
  'pages.messages.batch.modal.btnConfirmMerge': '确认封包并发送',
  'pages.messages.batch.modal.mergeSummary':
    '已通过接收方与标准一致性校验！将合并为 1 批，共包含 {count} 票业务单据。',
  'pages.messages.batch.modal.partnerLabel': '接收方交易伙伴',
  'pages.messages.batch.modal.versionLabel': '采用标准与版本',
  'pages.messages.batch.modal.controlNoLabel': '生成交换控制号',
  'pages.messages.batch.modal.estSizeLabel': '合并后预估大小',
  'pages.messages.batch.modal.reasonLabel': '合批操作备注 / 调度依据',
  'pages.messages.batch.modal.defaultReason': '班轮出港前批量封包发送',

  // P-23 归档与存储
  'pages.messages.archive.title': '归档与存储',
  'pages.messages.archive.desc':
    '面向运维与合规角色，统一监管热/冷分层存储、归档任务生命周期、冷数据安全回载与合规恢复演练。',
  'pages.messages.archive.btnApplyReload': '申请冷数据回载',
  'pages.messages.archive.wormNoticeTitle':
    '不可变合规性约束提示 (Immutable WORM Policy)',
  'pages.messages.archive.wormNoticeDesc':
    '根据《国际海事数字交换合规条例》与网络安全法规定：所有已归档报文受硬件级 WORM (Write Once Read Many) 保护，保留期限为 7 年 (2555 天)。系统内任何角色无权缩短保留期限或关闭 WORM 防篡改保护。',
  'pages.messages.archive.hotStorageTitle': '热存储容量 (在线区)',
  'pages.messages.archive.coldStorageTitle': '冷存储容量 (归档区)',
  'pages.messages.archive.messageCountLabel': '报文总量: ',
  'pages.messages.archive.earliestLabel': '最早数据: ',
  'pages.messages.archive.monthlyTasksTitle': '本月归档任务',
  'pages.messages.archive.failCountTag': '失败 {count} 次',
  'pages.messages.archive.latestTaskLabel': '最近任务: ',
  'pages.messages.archive.archiveStatusLabel': '任务状态: 全部定时转冷正常',
  'pages.messages.archive.retentionSummaryTitle': '法定保留策略 (只读)',
  'pages.messages.archive.retentionYearsLabel': '保留年限: ',
  'pages.messages.archive.yearsUnit': '年 (2555 天，只读锁定)',
  'pages.messages.archive.encryptionLabel': '密文算法: ',
  'pages.messages.archive.wormStatusLabel': 'WORM 状态: ',
  'pages.messages.archive.wormActiveTag': '硬件级已激活 (不可逆)',
  'pages.messages.archive.tabTasks': '归档任务列表 (Archive Tasks)',
  'pages.messages.archive.tabDrills': '恢复演练记录 (Recovery Drills)',
  'pages.messages.archive.drillsNotice':
    '列出历次灾备恢复演练范围、恢复耗时与哈希链无篡改校验结果，直接作为开发准入合规审计依据。',
  'pages.messages.archive.btnNewDrill': '发起合规恢复演练',
  'pages.messages.archive.retrySuccess': '归档任务已成功重新触发执行',
  'pages.messages.archive.reloadSuccess':
    '冷数据回载已成功申请并载入热区，P-11 可立即查询',
  'pages.messages.archive.drillSuccess': '恢复演练已成功记录并归档为合规证据',
  'pages.messages.archive.task.no': '任务编号',
  'pages.messages.archive.task.type': '任务类型',
  'pages.messages.archive.taskTypeHotToCold': '热转冷定时归档',
  'pages.messages.archive.taskTypeReload': '冷数据回载',
  'pages.messages.archive.task.range': '数据归档区间',
  'pages.messages.archive.task.count': '报文条数',
  'pages.messages.archive.task.startTime': '执行时间',
  'pages.messages.archive.task.status': '状态',
  'pages.messages.archive.taskStatusSuccess': '已完成',
  'pages.messages.archive.taskStatusFailed': '失败 (悬浮查看详情)',
  'pages.messages.archive.taskStatusRunning': '进行中',
  'pages.messages.archive.task.operator': '操作人 / 触发来源',
  'pages.messages.archive.task.actions': '操作',
  'pages.messages.archive.btnRetry': '重试任务',
  'pages.messages.archive.btnViewLogs': '查看日志',
  'pages.messages.archive.drill.no': '演练编号',
  'pages.messages.archive.drill.time': '演练时间',
  'pages.messages.archive.drill.scope': '抽检演练范围',
  'pages.messages.archive.drill.count': '抽检报文条数',
  'pages.messages.archive.drill.duration': '演练总耗时',
  'pages.messages.archive.drill.hash': '哈希完整性校验',
  'pages.messages.archive.hashPassed': '哈希链比对无篡改',
  'pages.messages.archive.hashFailed': '完整性异常',
  'pages.messages.archive.drill.result': '演练结论',
  'pages.messages.archive.drillPassed': '达标通过',
  'pages.messages.archive.drill.operator': '执行人',
  'pages.messages.archive.reloadModalTitle': '冷数据回载申请 (敏感操作审批)',
  'pages.messages.archive.btnConfirmReload': '提交回载申请',
  'pages.messages.archive.reloadNoticeTitle': '回载机制与访问权限说明',
  'pages.messages.archive.reloadNoticeDesc':
    '冷数据回载预计耗时 15 分钟。解冻落盘至热存储区后，相关报文将赋予申请人 7 天有效只读访问权，可在 P-11 报文查询中检索并查看原始报文。',
  'pages.messages.archive.reloadTimeRange': '申请回载的数据时间区间',
  'pages.messages.archive.reloadReason': '申请原因与审计审批单号',
  'pages.messages.archive.reloadReasonRequired': '请输入申请原因与审批依据',
  'pages.messages.archive.reloadReasonPlaceholder':
    '例：海关稽查调阅 2025 年 10 月远洋订舱单据，审批编号: AUDIT-2026-0889',
  'pages.messages.archive.logModalTitle': '归档任务执行轨迹与日志',
  'pages.messages.archive.logTaskNo': '任务编号',
  'pages.messages.archive.logType': '归档类型',
  'pages.messages.archive.logStatus': '执行状态',
  'pages.messages.archive.logError': '失败异常日志',
  'pages.messages.archive.logRetry': '重试记录',
  'pages.messages.archive.retryCountText': '已重试 {count} 次',
  'pages.messages.archive.drillModalTitle': '发起冷归档报文灾备恢复演练',
  'pages.messages.archive.btnStartDrill': '开始演练',
  'pages.messages.archive.drillScope': '演练抽检范围与批次',
  'pages.messages.archive.defaultDrillScope':
    '2025 年度远洋订舱报文随机抽检 (8000 票)',

  // 转换工作台 (Transformation Workbench)
  'pages.workflow.port.title': '端口设置',
  'pages.workflow.port.description': '端口描述',
  'pages.workflow.port.mappingSection': '映射',
  'pages.workflow.port.colSource': '源',
  'pages.workflow.port.dragToConnect':
    '拖动到目标字段建立映射，也可先点此行再点目标字段',
  'pages.workflow.port.colTarget': '目标',
  'pages.workflow.port.rowScript': '脚本',
  'pages.workflow.port.opExpression': '取值表达式',
  'pages.workflow.port.opFilter': '过滤条件',
  'pages.workflow.port.opScript': '脚本',
  'pages.workflow.port.opDelete': '删除该行',
  'pages.workflow.editor.openPort': '打开端口设置与映射',
  'pages.workflow.editor.confirm': '确定',
  'pages.workflow.editor.cancel': '取消',
  'pages.workflow.port.back': '返回流程',
  'pages.workflow.port.subtitle': '以真实报文为中心的可视化调试与映射设计器',
  'pages.workflow.port.perspective': '视角',
  'pages.workflow.port.perspectiveBaseline': '基线映射 (标准版本)',
  'pages.workflow.port.perspectivePartner': '{name} ({count}项覆盖)',
  'pages.workflow.port.overrideNotice':
    '当前处于【{partner}】视角，包含 {count} 项覆盖基线的个性化规则（以高亮边框和标签标出）',
  'pages.workflow.port.batchRegression': '批量回归',
  'pages.workflow.port.publish': '发布规则',
  'pages.workflow.port.save': '保存草稿',
  'pages.workflow.port.saveSuccess': '基线映射配置已成功保存',
  'pages.workflow.port.clearLineage': '清除血缘聚焦',
  'pages.workflow.port.activeFocus': '当前血缘聚焦：{name}',
  'pages.workflow.port.sourceTitle': '真实源报文 (EDI Source Message)',
  'pages.workflow.port.sourceSample': '样例库选择',
  'pages.workflow.port.sourceUpload': '本地上传',
  'pages.workflow.port.sourceProd': '从生产载入',
  'pages.workflow.port.selectSamplePlaceholder': '选择真实报文样例',
  'pages.workflow.port.uploadDraggerText':
    '点击或拖拽报文文件到此区域 (.edi, .txt)',
  'pages.workflow.port.uploadSuccess': '本地报文已成功载入：{name}',
  'pages.workflow.port.prodMsgIdPlaceholder':
    '输入报文编号 (如 MSG-20260921-08832)',
  'pages.workflow.port.prodLoadBtn': '载入',
  'pages.workflow.port.prodLoadSuccess': '已从生产环境调取并载入报文 {id}',
  'pages.workflow.port.segmentCount': '共 {count} 个段落',
  'pages.workflow.port.unusedTag': '未被使用',
  'pages.workflow.port.unusedAlert':
    '此报文段未被任何规则使用，可能是映射遗漏！',
  'pages.workflow.port.unusedCreateRule': '为此段创建规则',
  'pages.workflow.port.flowsToCount': '流向 {count} 个字段',
  'pages.workflow.port.segmentElements': '段内数据元解析',
  'pages.workflow.port.lineNo': '行号',
  'pages.workflow.port.rulesTitle': '目标结构与规则列表 (Target Rules Tree)',
  'pages.workflow.port.addRule': '添加规则',
  'pages.workflow.port.expandAll': '展开全部',
  'pages.workflow.port.collapseAll': '折叠全部',
  'pages.workflow.port.ruleTypeDirect': '直接映射',
  'pages.workflow.port.ruleTypeLoop': '循环映射',
  'pages.workflow.port.ruleTypeConditional': '条件映射',
  'pages.workflow.port.ruleTypeAggregation': '聚合映射',
  'pages.workflow.port.ruleTypeExpression': '表达式映射',
  'pages.workflow.port.ruleTypeDirectDesc':
    '标量字段一对一，支持基础清洗与类型转换',
  'pages.workflow.port.ruleTypeLoopDesc':
    '源段组重复 N 次生成目标集合，支持基数校验与嵌套子作用域',
  'pages.workflow.port.ruleTypeConditionalDesc':
    '按限定符或表达式分支，解决 EDIFACT 靠限定符复用段问题',
  'pages.workflow.port.ruleTypeAggregationDesc':
    '多个源节点归约为单一值 (求和/拼接/取首末)',
  'pages.workflow.port.ruleTypeExpressionDesc':
    '复杂业务逻辑脚本沙箱执行 (Groovy / JS)',
  'pages.workflow.port.ruleRequired': '必填',
  'pages.workflow.port.ruleUnmapped': '未映射',
  'pages.workflow.port.ruleMapped': '已映射',
  'pages.workflow.port.drilldownScope': '展开子作用域',
  'pages.workflow.port.exitScope': '返回根作用域',
  'pages.workflow.port.currentScope': '当前作用域：{scope}',
  'pages.workflow.port.scopeInstance': '段组实例：{instance}',
  'pages.workflow.port.scopeBreadcrumbRoot': '根报文',
  'pages.workflow.port.scopeBreadcrumbLoop': '循环: {name}',
  'pages.workflow.port.overrideTag': '伙伴覆盖',
  'pages.workflow.port.baselineTag': '基线规则',
  'pages.workflow.port.revertBaseline': '还原为基线',
  'pages.workflow.port.revertSuccess': '已还原为基线默认规则配置',
  'pages.workflow.port.editRule': '编辑',
  'pages.workflow.port.deleteRule': '删除',
  'pages.workflow.port.deleteConfirm':
    '确定删除该规则吗？右侧转换结果将立即重算。',
  'pages.workflow.port.inPlaceCreate': '就地创建规则',
  'pages.workflow.port.ruleDrawerTitleEdit': '编辑映射转换规则',
  'pages.workflow.port.ruleDrawerTitleCreate': '新建映射转换规则',
  'pages.workflow.port.fieldTargetPath': '目标字段路径',
  'pages.workflow.port.fieldRuleName': '规则名称',
  'pages.workflow.port.fieldRuleType': '规则类型',
  'pages.workflow.port.fieldSourcePath': '源段/元素路径',
  'pages.workflow.port.fieldTransform': '类型转换 / 函数',
  'pages.workflow.port.fieldConditionQualifier': '判定限定符 (如 NAD/3035)',
  'pages.workflow.port.fieldConditionBranches': '分支条件列表',
  'pages.workflow.port.fieldAggMethod': '聚合计算方式',
  'pages.workflow.port.fieldExpressionScript': '表达式脚本代码 (Groovy/JS)',
  'pages.workflow.port.saveAndRecalc': '保存并立即重算',
  'pages.workflow.port.ruleSaved': '规则已更新，转换结果已实时重算！',
  'pages.workflow.port.resultTitle': '转换结果与内部模型 (Result & Model)',
  'pages.workflow.port.viewStructured': '结构化视图',
  'pages.workflow.port.viewRawJson': 'JSON 原文',
  'pages.workflow.port.recalculatedTag': '实时重算',
  'pages.workflow.port.latencyMs': '耗时 {ms}ms',
  'pages.workflow.port.updatedBadge': '刚刚更新',
  'pages.workflow.port.requiredUnmappedError': '必填字段未被任何规则填充',
  'pages.workflow.port.clickToCreateInPlace': '点击就地创建规则',
  'pages.workflow.port.issuesTitle': '错误与告警提示',
  'pages.workflow.port.issuesCount': '{errorCount} 错误，{warnCount} 告警',
  'pages.workflow.port.noIssues': '无异常，转换结果已满足所有结构约束',
  'pages.workflow.port.lineageFrom': '源数据：{source}',
  'pages.workflow.port.lineageVia': '经过规则：{rule}',
  'pages.workflow.port.regressionTitle': '样例库批量回归测试',
  'pages.workflow.port.regressionSubtitle':
    '一键对当前映射绑定的全部样例执行自动化转换比对',
  'pages.workflow.port.regressionRunAll': '重新跑全量回归',
  'pages.workflow.port.regressionPassRate':
    '回归通过率：{rate}% ({passed}/{total})',
  'pages.workflow.port.regressionSuccess':
    '全量回归测试通过！所有样例转换符合预期。',
  'pages.workflow.port.regressionFailedAlert':
    '存在未通过的回归样例！发布前必须全部通过，否则系统将阻断发布。',
  'pages.workflow.port.colSampleName': '测试样例名称',
  'pages.workflow.port.colDuration': '耗时',
  'pages.workflow.port.colResult': '比对结果',
  'pages.workflow.port.colDetail': '失败原因与差异',
  'pages.workflow.port.colAction': '操作',
  'pages.workflow.port.loadSampleToWorkbench': '在工作台中复现',
  'pages.workflow.port.publishBlockedTitle': '发布已被阻断',
  'pages.workflow.port.publishBlockedDesc':
    '当前基线映射未达到发布准入标准，请修复以下阻断项：',
  'pages.workflow.port.publishBlockedUnmapped':
    '存在未被任何规则填充的必填字段：{fields}',
  'pages.workflow.port.publishBlockedRegression':
    '批量回归测试未全部通过 ({failedCount} 个用例失败)',
  'pages.workflow.port.publishSuccess':
    '报文类型已成功发布！已打上正式版本号并生效至全部订阅方。',
  'pages.workflow.port.closeModal': '关闭',

  // 映射工作台规范模型来源与只读提示

  // 业务过程列表

  // 业务过程详情

  // 端口清单与流程模型

  'pages.workflow.role.SOURCE': '起点',
  'pages.workflow.role.PROCESSOR': '中间',
  'pages.workflow.role.SINK': '终点',
  'pages.workflow.role.ANY': '通用',

  'pages.workflow.trigger.ACTIVE': '活动接收',
  'pages.workflow.trigger.PASSIVE': '被动接收',
  'pages.workflow.trigger.MANUAL': '手动接收',
  'pages.workflow.trigger.SCHEDULED': '定时触发',

  'pages.workflow.list.title': '工作流列表',
  'pages.workflow.list.subtitle': '管理端到端业务集成处理工作流与连接拓扑',
  'pages.workflow.list.colName': '工作流名称',
  'pages.workflow.list.colDirection': '方向',
  'pages.workflow.list.colPartner': '接入伙伴',
  'pages.workflow.list.colPortCount': '端口数',
  'pages.workflow.list.colStatus': '状态',
  'pages.workflow.list.colLast7dCount': '近 7 天处理量',
  'pages.workflow.list.colLast7dFailed': '近 7 天失败数',
  'pages.workflow.list.colUpdatedAt': '更新时间',
  'pages.workflow.list.searchPlaceholder': '搜索工作流名称或伙伴...',
  'pages.workflow.list.directionInbound': '入站',
  'pages.workflow.list.directionOutbound': '出站',
  'pages.workflow.list.statusEnabled': '启用',
  'pages.workflow.list.statusDisabled': '停用',
  'pages.workflow.list.statusDraft': '草稿',
  'pages.workflow.list.actionDetail': '查看详情',

  'pages.workflow.detail.title': '工作流详情',
  'pages.workflow.detail.back': '返回工作流列表',
  'pages.workflow.detail.basicInfo': '基本信息',
  'pages.workflow.detail.stats7d': '近 7 天统计',
  'pages.workflow.detail.canvasTitle': '工作流拓扑图',
  'pages.workflow.detail.canvasSubtitle':
    '可拖拽编辑：从左侧端口库拖入端口，拖动连接桩建立连线，改动后需保存',
  'pages.workflow.detail.drawerTitle': '端口详情',
  'pages.workflow.detail.portName': '实例名称',
  'pages.workflow.detail.portType': '端口类型',
  'pages.workflow.detail.portStatus': '运行状态',
  'pages.workflow.detail.upstreamPorts': '上游端口',
  'pages.workflow.detail.downstreamPorts': '下游端口',
  'pages.workflow.detail.noUpstream': '无上游端口 (工作流起点)',
  'pages.workflow.detail.noDownstream': '无下游端口 (工作流终点)',
  'pages.workflow.detail.statusRunning': '运行中',
  'pages.workflow.detail.statusStopped': '已停止',
  'pages.workflow.detail.statusError': '异常',
  'pages.workflow.detail.pathSuccess': '成功路径',
  'pages.workflow.detail.pathBranch': '分支路径',
  'pages.workflow.detail.pathError': '错误路径',
  'pages.workflow.detail.emptyFlow': '未找到工作流或数据为空',

  'pages.workflow.category.CORE': '基础',
  'pages.workflow.category.MFT': '可控文件传输',
  'pages.workflow.category.EDI': '电子数据交换',
  'pages.workflow.category.DATABASE': '数据库',
  'pages.workflow.category.OTHER': '其他',

  'pages.workflow.editor.save': '保存',
  'pages.workflow.editor.saving': '保存中...',
  'pages.workflow.editor.saveSuccess': '工作流已成功保存',
  'pages.workflow.editor.unsavedChanges': '有未保存改动',
  'pages.workflow.editor.reset': '重置',
  'pages.workflow.editor.resetConfirmTitle': '确认重置画布',
  'pages.workflow.editor.resetConfirmContent':
    '确定要放弃所有未保存的改动并重新加载吗？',
  'pages.workflow.editor.leaveConfirmTitle': '未保存改动',
  'pages.workflow.editor.leaveConfirmContent':
    '当前工作流有未保存的改动，确定要离开吗？',
  'pages.workflow.editor.leaveConfirmOk': '确定离开',
  'pages.workflow.editor.leaveConfirmCancel': '继续编辑',
  'pages.workflow.editor.paletteTitle': '端口库',
  'pages.workflow.editor.searchPortPlaceholder': '按名称或标识搜索端口类型...',
  'pages.workflow.editor.dragTip': '拖拽端口到画布添加实例',
  'pages.workflow.editor.noMatchingPorts': '未找到匹配的端口类型',
  'pages.workflow.editor.invalidSelfLoop': '不能将端口连接到自身',
  'pages.workflow.editor.invalidConnectFromSink':
    'SINK（终点）端口不支持拉出输出连线',
  'pages.workflow.editor.invalidConnectToSource':
    'SOURCE（起点）端口不支持作为输入目标',
  'pages.workflow.editor.invalidDuplicateConnection':
    '已存在从源端口到目标端口的连线',
  'pages.workflow.editor.branchNotAllowed':
    '只有支持多分支的端口（如 Branch）才允许拉出分支（BRANCH）连线',
  'pages.workflow.editor.branchLabelRequired': '分支连线必须填写分支条件标签',
  'pages.workflow.editor.branchLabelPlaceholder':
    '请输入分支条件标签（如：箱量 > 20）',
  'pages.workflow.editor.portDrawerTitle': '端口配置',
  'pages.workflow.editor.edgeDrawerTitle': '连线配置',
  'pages.workflow.editor.sourcePort': '源端口',
  'pages.workflow.editor.targetPort': '目标端口',
  'pages.workflow.editor.edgeType': '连线类型',
  'pages.workflow.editor.branchLabel': '分支标签',
  'pages.workflow.editor.deletePort': '删除端口',
  'pages.workflow.editor.deleteEdge': '删除连线',
  'pages.workflow.editor.deletePortConfirm': '确定要删除此端口及其所有连线吗？',
  'pages.workflow.editor.deleteEdgeConfirm': '确定要删除此连线吗？',
  'pages.workflow.editor.labelPending': '待填标签',
  'pages.workflow.editor.configSection': '配置项',
  'pages.workflow.editor.noConfigFields': '该端口类型暂无可配置项',
  'pages.workflow.editor.openWorkbench': '打开转换工作台',

  'pages.workflow.cfg.sourceTemplate': '源模板',
  'pages.workflow.cfg.targetTemplate': '目标模板',
  'pages.workflow.cfg.mappingVersion': '映射版本',
  'pages.workflow.cfg.encoding': '字符编码',
  'pages.workflow.cfg.condition': '分支条件',
  'pages.workflow.cfg.defaultBranch': '默认分支',
  'pages.workflow.cfg.splitMode': '拆分方式',
  'pages.workflow.cfg.delimiter': '分隔符',
  'pages.workflow.cfg.maxBatchSize': '单批上限',
  'pages.workflow.cfg.mergeKey': '合并键',
  'pages.workflow.cfg.mergeWindow': '合并窗口',
  'pages.workflow.cfg.ruleSet': '规则集',
  'pages.workflow.cfg.checkLevel': '校验级别',
  'pages.workflow.cfg.failurePolicy': '失败策略',
  'pages.workflow.cfg.scriptFile': '脚本文件',
  'pages.workflow.cfg.scriptLang': '脚本语言',
  'pages.workflow.cfg.timeoutMs': '超时',
  'pages.workflow.cfg.cron': '调度表达式',
  'pages.workflow.cfg.timezone': '时区',
  'pages.workflow.cfg.hasHeader': '含表头',
  'pages.workflow.cfg.quoteChar': '引号字符',
  'pages.workflow.cfg.rootPath': '根路径',
  'pages.workflow.cfg.outputFormat': '输出格式',
  'pages.workflow.cfg.fieldLength': '定长长度',
  'pages.workflow.cfg.padChar': '填充字符',
  'pages.workflow.cfg.channel': '通知渠道',
  'pages.workflow.cfg.recipients': '接收人',
  'pages.workflow.cfg.notifyLevel': '通知级别',
  'pages.workflow.cfg.targetPath': '目标路径',
  'pages.workflow.cfg.overwrite': '覆盖同名文件',
  'pages.workflow.cfg.discardReason': '丢弃原因',
  'pages.workflow.cfg.logDiscard': '记录丢弃日志',
  'pages.workflow.cfg.endpoint': '传输地址',
  'pages.workflow.cfg.as2Id': 'AS2 标识',
  'pages.workflow.cfg.certAlias': '证书别名',
  'pages.workflow.cfg.retryCount': '重试次数',
  'pages.workflow.cfg.host': '主机地址',
  'pages.workflow.cfg.port': '端口',
  'pages.workflow.cfg.username': '用户名',
  'pages.workflow.cfg.remoteDir': '远程目录',
  'pages.workflow.cfg.privateKeyAlias': '私钥别名',
  'pages.workflow.cfg.rootDir': '根目录',
  'pages.workflow.cfg.allowedUsers': '允许用户',
  'pages.workflow.cfg.bucket': '存储桶',
  'pages.workflow.cfg.prefix': '对象前缀',
  'pages.workflow.cfg.region': '区域',
  'pages.workflow.cfg.credentialAlias': '凭证别名',
  'pages.workflow.cfg.pgpOperation': 'PGP 操作',
  'pages.workflow.cfg.keyAlias': '密钥别名',
  'pages.workflow.cfg.algorithm': '加密算法',
  'pages.workflow.cfg.messageType': '报文类型',
  'pages.workflow.cfg.version': '版本',
  'pages.workflow.cfg.declareType': '申报类型',
  'pages.workflow.cfg.companyCode': '企业代码',
  'pages.workflow.cfg.receiptTimeout': '回执超时',
  'pages.workflow.cfg.connection': '数据库连接',
  'pages.workflow.cfg.operation': '操作类型',
  'pages.workflow.cfg.table': '表名',
  'pages.workflow.cfg.schema': 'Schema',
  'pages.workflow.cfg.topic': '主题',
  'pages.workflow.cfg.groupId': '消费组',
  'pages.workflow.cfg.partitionKey': '分区键',
  'pages.workflow.cfg.exchange': '交换机',
  'pages.workflow.cfg.routingKey': '路由键',
  'pages.workflow.cfg.queue': '队列',
  'pages.workflow.cfg.url': '请求地址',
  'pages.workflow.cfg.method': '请求方法',
  'pages.workflow.cfg.authMode': '认证方式',
  'pages.workflow.cfg.webhookPath': '回调路径',
  'pages.workflow.cfg.signSecretAlias': '签名密钥别名',

  'pages.workflow.cfgOpt.ynYes': '是',
  'pages.workflow.cfgOpt.ynNo': '否',
  'pages.workflow.cfgOpt.encUtf8': 'UTF-8',
  'pages.workflow.cfgOpt.encGbk': 'GBK',
  'pages.workflow.cfgOpt.encLatin1': 'ISO-8859-1',
  'pages.workflow.cfgOpt.fmtXml': 'XML',
  'pages.workflow.cfgOpt.fmtJson': 'JSON',
  'pages.workflow.cfgOpt.opQuery': '查询',
  'pages.workflow.cfgOpt.opWrite': '写入',
  'pages.workflow.cfgOpt.opProc': '存储过程',
  'pages.workflow.cfgOpt.brError': '转入错误路径',
  'pages.workflow.cfgOpt.brDiscard': '丢弃',
  'pages.workflow.cfgOpt.splitLine': '按行',
  'pages.workflow.cfgOpt.splitRecord': '按记录',
  'pages.workflow.cfgOpt.splitDelimiter': '按分隔符',
  'pages.workflow.cfgOpt.lvlStrict': '严格',
  'pages.workflow.cfgOpt.lvlLoose': '宽松',
  'pages.workflow.cfgOpt.lvlError': '仅错误',
  'pages.workflow.cfgOpt.lvlWarn': '警告及以上',
  'pages.workflow.cfgOpt.lvlAll': '全部',
  'pages.workflow.cfgOpt.failAbort': '中断流程',
  'pages.workflow.cfgOpt.failWarn': '告警并继续',
  'pages.workflow.cfgOpt.langGroovy': 'Groovy',
  'pages.workflow.cfgOpt.langJs': 'JavaScript',
  'pages.workflow.cfgOpt.langPython': 'Python',
  'pages.workflow.cfgOpt.tzShanghai': 'Asia/Shanghai',
  'pages.workflow.cfgOpt.tzUtc': 'UTC',
  'pages.workflow.cfgOpt.tzTokyo': 'Asia/Tokyo',
  'pages.workflow.cfgOpt.tzLondon': 'Europe/London',
  'pages.workflow.cfgOpt.chEmail': '邮件',
  'pages.workflow.cfgOpt.chSms': '短信',
  'pages.workflow.cfgOpt.chWebhook': 'Webhook',
  'pages.workflow.cfgOpt.chWecom': '企业微信',
  'pages.workflow.cfgOpt.pgpEncrypt': '加密',
  'pages.workflow.cfgOpt.pgpDecrypt': '解密',
  'pages.workflow.cfgOpt.pgpSign': '签名',
  'pages.workflow.cfgOpt.pgpVerify': '验签',
  'pages.workflow.cfgOpt.algAes256': 'AES-256',
  'pages.workflow.cfgOpt.algRsa2048': 'RSA-2048',
  'pages.workflow.cfgOpt.alg3des': '3DES',
  'pages.workflow.cfgOpt.mGet': 'GET',
  'pages.workflow.cfgOpt.mPost': 'POST',
  'pages.workflow.cfgOpt.mPut': 'PUT',
  'pages.workflow.cfgOpt.mDelete': 'DELETE',
  'pages.workflow.cfgOpt.authNone': '无',
  'pages.workflow.cfgOpt.authBasic': 'Basic',
  'pages.workflow.cfgOpt.authBearer': 'Bearer',
  'pages.workflow.cfgOpt.authOauth2': 'OAuth2',
  'pages.audit.result.success': '成功',
  'pages.audit.result.failed': '失败',
};
